"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require("../../../mixins/colors");

exports.default = {
  name: "DatePickerPreview",

  props: {
    value: {
      type: String,
      required: false,
      default: ""
    },

    color: {
      type: String,
      required: false,
      default: _colors.DEFAULT_INPUT_TEXT_COLOR
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/forms/elements/DatePickerPreview.vue
// module id = i132
// module chunks = 0 1